import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import React, { useState, useEffect } from "react";
import { Column } from "primereact/column";
import { TreeTable } from "primereact/treetable";
import * as Fa from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import storage from "../../../Services/Storage";
import Axios from "../../../api/Axios";

let updateCount = 0;

const Privilege = () => {
    const auth = storage.getLocal("user");
    const [loader, setLoader] = useState(null);
    const [rawData, setRawData] = useState();
    const [allPrivData, setAllPrivData] = useState();
    const [viewButton, setViewButton] = useState(false);
    const [dataLossState, setDataLossState] = useState(false);
    const [expandedKeys, setExpandedKeys] = useState({});
    const [selectedPriv, setSelectedPriv] = useState([]);
    const [selectedPrivDropDown, setSelectedPrivDropDown] = useState([]);
    // const nav = useNavigate();
    const privDropDown = ["Create", "Update", "View", "None"];
    const [searchParam] = useSearchParams();
    //   const UserId = localStorage.getItem("UserId")?.toString();
    const grid = searchParam.get("GRID");
    const isNew = searchParam.get("New");

    const url = "UserGroups/Priviledge/";
    const GetAllGroup_url = `${url}GetAllUserGroupData?`;
    const GetCreate_url = `${url}CreatePrivilege?`;
    const Getupdate_url = `${url}UpdatePrivilege?`;
    const GetView_url = `${url}ViewOnlyAllPrivilege?`;
    const GetNone_url = `${url}NonePrivilege?`;
    const GetSave_url = `${url}SavePrivilledge?`;

    const populatePrivData = async () => {
        setLoader(true);
        try {
            const AllUser_Url = `${GetAllGroup_url}CompId=${auth.CompId}&strGroupID=${grid}`;
            const response = await Axios.get(AllUser_Url);
            console.log("responseuserpre", response);

            setRawData(response.data.Data);

            const mappedTreeData = buildTreeStructure(response.data.Data);
            setAllPrivData(mappedTreeData);
        } catch (error) {
            toast.error("Something Went Wrong. Please Contact Helpdesk.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.error(error);
        } finally {
            setLoader(false);
        }
    };

    const buildTreeStructure = (data) => {
        const tree = [];
        const childrenMap = {};

        data.forEach((item) => {
            const node = {
                key: item.MASK_MENU_ID.toString(),
                data: item,
                children: [],
            };

            childrenMap[item.MASK_MENU_ID] = node;

            if (item.MASK_PARENT === null) {
                tree.push(node);
            } else {
                if (childrenMap[item.MASK_PARENT]) {
                    childrenMap[item.MASK_PARENT].children.push(node);
                } else {
                    childrenMap[item.MASK_PARENT] = { children: [node] };
                }
            }
        });

        return tree;
    };
    //eslint-disable-next-line
    const findNodeByKey = (nodes, key) => {
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].key === key) {
                return nodes[i];
            } else if (nodes[i].children.length) {
                const found = findNodeByKey(nodes[i].children, key);
                if (found) return found;
            }
        }
        return null;
    };

    const collapseAll = () => {
        setExpandedKeys({});
    };

    const expandAll = () => {
        const newExpandedKeys = {};
        const expandRecursive = (nodes) => {
            nodes.forEach((node) => {
                newExpandedKeys[node.key] = true;
                if (node.children && node.children.length) {
                    expandRecursive(node.children);
                }
            });
        };
        expandRecursive(allPrivData);
        setExpandedKeys(newExpandedKeys);
    };

    const onSelectRow = (e) => {
        try {
            setSelectedPriv(e);
            const selectedKeys = Object.keys(e).map((key) => parseInt(key));
            setViewButton(selectedKeys.length > 0);
        } catch (ex) {
            toast.error(ex);
        }
    };

    const SaveClick = async () => {
        setLoader(true);
        try {
            if (updateCount === 0) {
                toast.warn("No Changes to Save", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                setLoader(false);
                return;
            }

            const _savePrivilegeList = rawData.map((a) => ({
                pvcmenU_ID: a.MASK_MENU_ID.toString(),
                pvcusR_GR_ID: a.MASK_USR_GR_ID,
                pvcuprV_TAG: a.MASK_ALLOWED,
                compId: auth.CompId,
            }));

            const objSave = {
                savePrivilegeList: _savePrivilegeList,
            };

            const response = await Axios.post(GetSave_url, objSave, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.data) {
                toast.success(`${response.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                populatePrivData;
                setDataLossState(false);
                populatePrivData();
                setSelectedPrivDropDown([]);
            }
        } catch (error) {
            toast.error("Something Went Wrong. Please Contact Helpdesk.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.log(error);
            setLoader(false);
        }
    };

    const PrivilegeClick = async (data) => {
        try {
            setSelectedPrivDropDown(data);

            if (dataLossState) {
                toast.warn("Please click on save before further modification", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }

            const selectedKeys = Object.keys(selectedPriv).map((key) =>
                parseInt(key)
            );
            const filteredData = rawData.filter((item) =>
                selectedKeys.includes(item.MASK_MENU_ID)
            );

            const obj = {
                compId: auth.CompId,
                menuIdList: filteredData.map((res) => res.MASK_MENU_ID.toString()),
                menuNameList: filteredData.map((res) => res.MENU_DESC),
                pvcgroupid: grid,
            };

            let apiUrl = "";
            if (data === "Create") {
                apiUrl = GetCreate_url;
            } else if (data === "Update") {
                apiUrl = Getupdate_url;
            } else if (data === "View") {
                apiUrl = GetView_url;
            } else if (data === "None") {
                apiUrl = GetNone_url;
            }

            const response = await Axios.post(apiUrl, obj);
            console.log("responsedrop", response);

            const treeData = buildTreeStructure(response.data.Data);
            setRawData(response.data.Data);
            setAllPrivData(treeData);
            setSelectedPriv([]);
            updateCount += 1;
            setDataLossState(true);
        } catch (ex) {
            toast.error(
                ex?.response?.data?.Message ||
                "Something went wrong. Please contact Helpdesk."
            );
            setSelectedPriv([]);
        }
    };

    useEffect(() => {
        populatePrivData();
    }, []);

    if (loader) {
        return <Loader />;
    } else {
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-3 col-md-12 col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mx-1">
                                    <li className="breadcrumb-item">
                                        <Link to="/usermanagement/usergroup">User Groups</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Privilage
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-9 col-md-12 col-sm-12">
                            <div className="text-end">
                                <Link to="/usermanagement/usergroup/usergroupfield">
                                    <button type="submit" className="btn btn-primary me-2">
                                        <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                                        Records
                                    </button>
                                </Link>
                                <button
                                    type="submit"
                                    title="Save"
                                    className="btn btn-primary me-2"
                                    onClick={SaveClick}
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={expandAll}
                                >
                                    Expand All
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={collapseAll}
                                >
                                    Collapse All
                                </button>
                                <Dropdown
                                    value={selectedPrivDropDown}
                                    options={privDropDown}
                                    placeholder="Select a Privilege"
                                    className="w-25 ms-2"
                                    onChange={(e) => PrivilegeClick(e.value)}
                                    disabled={!viewButton}
                                />
                            </div>
                        </div>
                    </div>
                    <section className="sales-box">
                        {isNew === "Y" && <p>ABC</p>}
                        <div className="row">
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <div className="DataTable">
                                    <TreeTable
                                        value={allPrivData}
                                        // showGridlines
                                        stripedRows
                                        scrollHeight="80vh"
                                        // paginator
                                        // rows={10}
                                        scrollable
                                        // togglerTemplate={togglerTemplate}
                                        expandedKeys={expandedKeys}
                                        onToggle={(e) => setExpandedKeys(e.value)}
                                        selectionMode="checkbox"
                                        selectionKeys={selectedPriv}
                                        onSelectionChange={(e) => onSelectRow(e.value)}
                                    // rowClassName={(rowData)=>({
                                    //     className: selectedPriv === rowData ? 'highlighted-row' : ''
                                    // })}
                                    >
                                        <Column
                                            expander
                                            style={{ width: "7rem" }}
                                            className="line"
                                        ></Column>
                                        <Column field="PAGE" header="Menu Name"></Column>
                                        <Column
                                            field="PRIVILEGE_TAG"
                                            header="Privilege"
                                            style={{ width: "7rem" }}
                                        ></Column>
                                    </TreeTable>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <img
                                    src={require("../../../Assets/Images/users_group.png")}
                                    className="Side_Img w-100"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
};

export default Privilege;